module.exports = __webpack_public_path__ + "static/media/md-pint.0e585f33.svg";